(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ollin-product-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ollin-product-proof')) {
    customElements.define('ollin-product-proof', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        const details = this.querySelector('.op-video-details');
        const player = this.querySelector('.op-player');
        if (!details || !player) return;
        details.addEventListener('toggle', () => {
          if (!details.open || player.getAttribute('src')) return;
          let candidate;
          try { candidate = new URL(player.dataset.videoSrc); } catch { return; }
          const isTikTok = candidate.origin === 'https://www.tiktok.com' && /^\/player\/v1\/\d{10,25}$/.test(candidate.pathname);
          const isYouTube = candidate.origin === 'https://www.youtube-nocookie.com' && /^\/embed\/[A-Za-z0-9_-]{11}$/.test(candidate.pathname);
          if (!isTikTok && !isYouTube) return;
          if (candidate.searchParams.get('autoplay') !== '0') return;
          player.src = candidate.href;
          player.focus({ preventScroll: true });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
